$(function () {
   console.log('Hello World');
   vvipDiscount();
   removePopupGift();
   setGiftPopupHeight();
   setTheGiftToggleButton();
    // order date filter - Start
    initInlineDatePicker();
    getPaginateData();
    // order date filter - End
    onloadOrderGallery();
    onloadOrderReorderBtn();
    handleMobileMultiColumns();
    handleMobileCategoriesList();
    $(window).on('resize', function() {
        setGiftPopupHeight();
        handleMobileMultiColumns();
        handleMobileCategoriesList();
    });
});

// Start - VVIP discount code
vvipDiscount = () => {
   const discountList = $('.discounts__discount');
   var $isAppliedDiscount = false;
   if (discountList.length > 0) {
      discountList.each(function(index, discount) {
         console.log('discount: ', discount);
         var discountTitle = $(discount).text().toLowerCase();
         if (discountTitle.includes('vvip100')) {
            $isAppliedDiscount = true
         }
      });
   }

   console.log('isAppliedDiscount: ', $isAppliedDiscount);
    if (window.location.pathname.includes('/cart')) {
        if ($('.isVvipDiscount').length && !$isAppliedDiscount) {
            var $discCode = $('.isVvipDiscount').val();
            sessionStorage.setItem("vvipApplied", true);
            console.log('isAppliedDiscount: ', $isAppliedDiscount);
            console.log('vvipApplied: ',$discCode);
            
            window.location.href = `/discount/${$discCode}?redirect=/cart`;
        }
    }
}
// End - VVIP discount code

openPopup = (t, e) => {
   e.preventDefault(); // Prevent the default behavior of the click event
   
   var $this = $(t);

   $this.parents('.jsc-cart-item-gift').find('.jsc-gift-popup').show();
}

closePopup = (e) => {
   var $this = $(e);

   $this.parents('.jsc-gift-popup').hide();
}

let $typingTimer;
const $delay = 1000; // Adjust delay as needed

onInputQty = (e, getQty) => {
    clearTimeout($typingTimer);
    $typingTimer = setTimeout(function () {
        var $this = $(e);
        var $thisVal = parseInt($this.val()) || 0;
        var $container = $this.closest('.jsc-gift-grid-container');
        var $qtyInputs = $container.find('.jsc-qty-input');
        var $totalSelected = 0;

        // Calculate total selected quantity
        $qtyInputs.each(function () {
            $totalSelected += parseInt($(this).val()) || 0;
        });

        var $maxAllowed = getQty - ($totalSelected - $thisVal);

        // Prevent exceeding max allowed
        if ($thisVal > $maxAllowed) {
            $this.val($maxAllowed);
            $totalSelected = getQty;
        }

        // Update disabled state for other inputs
        $qtyInputs.each(function () {
            var _this = $(this);
            var _val = parseInt(_this.val()) || 0;
            var _maxAllowed = getQty - ($totalSelected - _val);
            _this.attr("max", _maxAllowed); // Set max attribute dynamically
        });

        // Update quantity display
        $('.jsc-add-qty').text($totalSelected);

        // Enable/Disable "Add to Cart" button
        var $addToCartBtn = $this.closest('.jsc-gift-popup').find('.jsc-product-form--atc-button');
        if ($totalSelected === getQty) {
            $addToCartBtn.removeAttr("disabled").removeClass('disabled');
        } else {
            $addToCartBtn.attr("disabled", "disabled").addClass('disabled');
        }
    }, $delay);
}

updateGiftQty = (btn, getQty) => {
    var $btn = $(btn);
    var $input = $btn.siblings('.jsc-qty-input');
    setTimeout(() => {
        onInputQty($input[0], getQty);
    }, 10);
}

addPopupGift = (e, evt, p, tier) => {
   evt.preventDefault(); // Prevent the default behavior of the click event
   var $loader = $('.jsc-loader-overlay');
   $loader.show();
   var $this = $(e);
   var $thisQtyFields = $this.parents('.jsc-gift-popup').find('.jsc-qty-input');
   var $lineItemArray = [];

   $this.addClass('disabled').attr('disabled', 'disabled');
   
   $thisQtyFields.each(function () {
       var $lineItemObj = {};
       var _this = $(this);
       var _vid = parseInt(_this.attr('data-vid'));
       var _qty = parseInt(_this.val());
       
       if (_qty > 0) {
           $lineItemObj['id'] = _vid;
           $lineItemObj['quantity'] = _qty;
           $lineItemObj['properties'] = {
               "_GWP": "True",
               "_Promo": `promo_${p}_${tier}`,
               "_Promo_no": p,
               "_Tier_no": tier,
               "_GWP_type": "select"
           };   
           $lineItemArray.push($lineItemObj);
       }
       
   });
   cartJSMultiAddQuery($lineItemArray);
   $(document).on('cart.requestComplete', function(event, cart) {
       // Event handling here.
   });
}

cartJSMultiAddQuery = (obj) => {
   CartJS.addItems(obj,
   {
       // Define a success callback to display a success message.
       "success": function(data, textStatus, jqXHR) {
            fetch('/cart').then((response) => {
               console.log('success multi');
               // location.reload();
               fetch(`${routes.cart_url}?section_id=main-cart-items`)
               .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const newCartContent = html.querySelector('cart-items'); // New cart content
                
                    if (newCartContent) {
                        const currentCart = document.querySelector('cart-items'); // Existing cart content
                        if (currentCart) {
                            currentCart.innerHTML = newCartContent.innerHTML; // Update cart content
                        }
                    }
                    // toggleGiftAccordion();
                })
               .catch(e => {
                    console.error("Error updating cart:", e);
                });
             
            }).catch((e) => {
                console.error(e);
            });     
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", errorThrown, jqXHR);
        }
   });
}

updatePopupGift = (e, evt, p, tier) => {
   evt.preventDefault(); // Prevent the default behavior of the click event
   var $loader = $('.jsc-loader-overlay');
   $loader.show();
   var $this = $(e);
   var $thisQtyFields = $this.parents('.jsc-gift-popup').find('.jsc-qty-input');
   var $updateObj = {};
   var $lineItemArray = [];
   var promoTier = `promo_${p}_${tier}`;
   $this.addClass('disabled').attr('disabled', 'disabled');

   $.getJSON('/cart.js', function(cart) {
       // We can access cart info
       for (const item of cart.items) {
           if (item.properties['_GWP_type'] == 'select' && item.properties['_Promo'] == promoTier) {

               $thisQtyFields.each(function () {
                   var _this = $(this);
                   var _vid = parseInt(_this.attr('data-vid'));
                   var _qty = parseInt(_this.val());
                   var _promoTier = _this.attr('promo-tier');
                   if (_vid == item.variant_id && promoTier == _promoTier) {
                       $updateObj[item.key] = _qty;
                   }
               });
           }
       }
   }).then(function () {
       $thisQtyFields.each(function () {
           var $lineItemObj = {};
           var _this = $(this);
           var _vid = parseInt(_this.attr('data-vid'));
           var _qty = parseInt(_this.val());
           var _promoTier = _this.attr('promo-tier');

           if (!containsInKey($updateObj, _vid) && _qty > 0 && promoTier == _promoTier) {
               $lineItemObj['id'] = _vid;
               $lineItemObj['quantity'] = _qty;
               $lineItemObj['properties'] = {
                   "_GWP": "True",
                   "_Promo": `promo_${p}_${tier}`,
                   "_Promo_no": p,
                   "_Tier_no": tier,
                   "_GWP_type": "select"
               };   
               $lineItemArray.push($lineItemObj);
           }
       });
       if ($lineItemArray.length > 0) {
           cartJSMultiAddQuery($lineItemArray);
       }
       if (!$.isEmptyObject($updateObj)) {
           cartJSMultiUpdateQuery($updateObj);
       }
   });

   $(document).on('cart.requestComplete', function(event, cart) {
       // Event handling here.
   });
}

addAddOnProduct = (e, var_id) => {
   var $this = $(e);
   var $spinner = $this.find('.loading-overlay__spinner');
   var $buttonText = $this.find('span');
   var originalButtonText = $buttonText.text();
   var originalButtonHTML = $this.html();
   
   // Show loading spinner and disable button
   $spinner.removeClass('hidden');
   $spinner.find('svg').show();
   $this.addClass('disabled').attr('disabled', 'disabled');
   $buttonText.text('');
   
   // Add item to cart using CartJS
   CartJS.addItem(var_id, 1, {}, {
       "success": function(data, textStatus, jqXHR) {
           console.log('Add-on product added successfully');
           
           // Update cart drawer
           fetch(`${window.Shopify.routes.root}?sections=cart-drawer`)
           .then(response => response.json())
           .then(data => {
               let tempDiv = document.createElement("div");
               tempDiv.innerHTML = data['cart-drawer'];
               
               let newCartDrawerContent = tempDiv.querySelector("#CartDrawer")?.innerHTML;
               if (newCartDrawerContent) {
                   if (window.location.pathname.includes('/cart')) {
                       // On cart page, reload to show updated cart
                       location.reload();
                   } else {
                       // Update cart drawer
                       document.getElementById("CartDrawer").innerHTML = newCartDrawerContent;
                       document.querySelector("cart-drawer").classList.add("active");
                       
                       // Update cart count
                       var cartItemCountElement = document.querySelector(".jsc-cart-drawer-item-count");
                       if (cartItemCountElement) {
                           let itemCount = cartItemCountElement.getAttribute("data-cart-item-count");
                           let cartIcon = document.querySelector(".header__cart .header__icon.header__icon--cart");
                           
                           if (cartIcon) {
                               let cartBubble = cartIcon.querySelector(".cart-count-bubble");
                               if (cartBubble) {
                                   cartBubble.innerHTML = itemCount;
                               } else {
                                   cartBubble = document.createElement("div");
                                   cartBubble.className = "cart-count-bubble";
                                   cartBubble.innerHTML = `<span aria-hidden="true">${itemCount}</span><span class="visually-hidden">${itemCount} item(s)</span>`;
                                   cartIcon.appendChild(cartBubble);
                               }
                           }
                       }
                       
                       // Update gift popup height if needed
                       if (typeof setGiftPopupHeight === 'function') {
                           setGiftPopupHeight();
                       }
                   }
               }
           })
           .catch(error => console.error("Error updating cart drawer:", error));
           
           // Reset button state
           $spinner.addClass('hidden');
           $this.removeClass('disabled').removeAttr('disabled');
           $buttonText.text(originalButtonText);
           
           // Show success message
           setTimeout(() => {
               $this.html(originalButtonHTML);
           }, 2000);
       },
       "error": function(jqXHR, textStatus, errorThrown) {
           console.log("Error adding add-on product:", errorThrown, jqXHR);
           
           // Reset button state on error
           $spinner.addClass('hidden');
           $this.removeClass('disabled').removeAttr('disabled');
           $buttonText.text(originalButtonText);
           
           // Show error message
           $this.text('Error - Try Again').addClass('error');
           setTimeout(() => {
               $this.html(originalButtonHTML);
               $this.removeClass('error');
           }, 2000);
       }
   });
}

containsInKey = (myObject, keyToCheck) => {
    var keyExists = false;
    $.each(myObject, function(key, value) {
        if (key.includes(keyToCheck)) {
            keyExists = true;
        }
    });
    return keyExists;
}

removePopupGift = () => {
   if ($('.jsc-remove-foc').length > 0) {
       var $removeObj = {};
       $('.jsc-remove-foc').each(function () {
           var _this = $(this);
           var _key = _this.val();

           $removeObj[_key] = 0;
       });

       if (!$.isEmptyObject($removeObj)) {
           var $loader = $('.jsc-loader-overlay');
           $loader.show();
           cartJSMultiUpdateQuery($removeObj);
       }
    
       $(document).on('cart.requestComplete', function(event, cart) {
           // Event handling here.
           $loader.hide();
           // location.reload();
       });
   }
}

cartJSMultiUpdateQuery = (obj) => {
    CartJS.updateItemQuantitiesById(obj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
            fetch('/cart').then((response) => {
                console.log('success multi update');
                // location.reload();
                fetch(`${routes.cart_url}?section_id=main-cart-items`)
                .then((response) => response.text())
                 .then((responseText) => {
                     const html = new DOMParser().parseFromString(responseText, 'text/html');
                     const newCartContent = html.querySelector('cart-items'); // New cart content
                 
                     if (newCartContent) {
                         const currentCart = document.querySelector('cart-items'); // Existing cart content
                         if (currentCart) {
                             currentCart.innerHTML = newCartContent.innerHTML; // Update cart content
                             setGiftPopupHeight();
                         }
                     }
                    //  toggleGiftAccordion();
                 })
                .catch(e => {
                    console.error("Error updating cart:", e);
                });
            }).catch((e) => {
                console.error(e);
            });
            fetch(`${window.Shopify.routes.root}?sections=cart-drawer`)
            .then(response => response.json())
            .then(data => {
              // Create a temporary div to parse the returned HTML
              let tempDiv = document.createElement("div");
              tempDiv.innerHTML = data['cart-drawer'];
          
              // Get the updated content inside #CartDrawer
              let newCartDrawerContent = tempDiv.querySelector("#CartDrawer")?.innerHTML;
              if (newCartDrawerContent) {
                // Replace only the inner content of #CartDrawer
                if (window.location.pathname.includes('/cart')) {
                }else{
                    document.getElementById("CartDrawer").innerHTML = newCartDrawerContent;
                    setGiftPopupHeight();
                }
              }
            })
            .catch(error => console.error("Error updating cart drawer:", error));
    
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log("Error occur !", errorThrown, jqXHR);
        }
    });
}

setTheGiftToggleButton = () => {
    $(document).on("click", ".toggleGiftButton", function () {
        var $clickedButton = $(this);
        var $button_id = $clickedButton.attr('id');
        var $giftCartItems = $(`.gift-cart-items.${$button_id}`);
        var $plusIcon = $clickedButton.find(".gift-plus-icon");
        var $minusIcon = $clickedButton.find(".gift-minus-icon");
    
        if (!$giftCartItems.length || !$plusIcon.length || !$minusIcon.length) {
            console.warn("One or more elements are missing:", { $giftCartItems, $plusIcon, $minusIcon });
            return;
        }
    
        // Toggle visibility
        if ($giftCartItems.is(":hidden")) {
            $giftCartItems.css("display", "table");
            $plusIcon.hide();
            $minusIcon.css("display", "flex");
        } else {
            $giftCartItems.hide();
            $plusIcon.css("display", "flex");
            $minusIcon.hide();
        }
    })
}

setGiftPopupHeight = () => {
    if (window.location.pathname.includes('/cart')) {
        var popupContent = $('.jsc-gift-popup.jsc-cart-gift-popup');
    }else{
        var popupContent = $('.jsc-gift-popup.jsc-cart-drawer-gift-popup');
    }


    if (popupContent.length === 0) {
        // console.warn("Element not found: gift popup");
        return;
    }

    // Store the inline styles
    var originalStyle = popupContent.attr('style');
    popupContent.css({
        'visibility': 'hidden',
        'display': 'block',
        'position': 'fixed',
        'top': '0',
        'z-index': '1000',
        'width': '100%',
        'height': '100%',
        'left': '0',
    });

    var newPopupTotalHeight = 0;
    var totalOfMargin = 30;
    var popupTopPanelHeight = popupContent.find('.jsc-gift-popup-top-panel').outerHeight() || 0;
    var jscGridContainerHeight = popupContent.find('.jsc-gift-grid-container .jsc-gift-grid').outerHeight() || 0;

    if (window.innerWidth <= 480) {
        var mobileButtonContainerHeight = popupContent.find('.mobile-button-container').outerHeight() || 0;
        newPopupTotalHeight = popupTopPanelHeight + jscGridContainerHeight + totalOfMargin + mobileButtonContainerHeight;
    } else {
        newPopupTotalHeight = popupTopPanelHeight + jscGridContainerHeight + totalOfMargin;
    }

    // Restore original styles
    if (originalStyle !== undefined && originalStyle !== null) {
        popupContent.attr('style', originalStyle);
    } else {
        popupContent.removeAttr('style');
    }
    popupContent.find('.jsc-gift-popup-content').css('height', newPopupTotalHeight);
}

//Start: Account page orders date filter

let tableRows = [];
let filteredOrderTable;

fetchTableRows = (page) => {
    var hostName = new URL(window.location.href).origin;
    return $.ajax({
        url: `${hostName}/account?page=${page}`,
        type: 'GET',
    }).then((data) => {
        const rows = $(data).find('.order-table .row.tbody');
        // Convert each row to an HTML string or an object
        const extractedRows = rows.map((index, row) => $(row)[0].outerHTML).get();
        tableRows.push(...extractedRows);
    }).catch((error) => {
        console.log(`Error fetching page ${page}: `, error);
    });
};
getPaginateData = () => {
    let orderPages = 1;
    let customerId = '';

    if ($('#total-order-page').length > 0) {
        orderPages = parseInt($('#total-order-page').val(), 10);
    }
    if ($('#customerId').length > 0) {
        customerId = $('#customerId').val();
    }

    if (orderPages > 0 && customerId != '') {
        var customerId_pages = localStorage.getItem('customerId_pages');
        if (!customerId_pages) {
            localStorage.setItem('customerId_pages', `${customerId}_${orderPages}`);
        }
    }

    customerId_pages = localStorage.getItem('customerId_pages');
    const orderTableRows = localStorage.getItem('orderTableRows');
    const [storedCustId, storedOrderPages] = customerId_pages.split('_');

    if (!orderTableRows || storedCustId != customerId || storedOrderPages != orderPages) {
        localStorage.setItem('customerId_pages', `${customerId}_${orderPages}`);
        const promises = [];

        // Loop through the pages and create promises
        for (let i = 1; i <= orderPages; i++) {
            promises.push(fetchTableRows(i));
        }

        // Wait for all promises to resolve
        Promise.all(promises).then(() => {
            localStorage.setItem('orderTableRows', JSON.stringify(tableRows));
        });
    }

    getFilteredOrder();
}

getFilteredOrder = () => {
    console.log('in getFilteredOrder');
    let params = new URLSearchParams(window.location.search);
    let startDateParam = params.get('startDate');
    let endDateParam = params.get('endDate');
    var $loader = $('.jsc-loader-overlay');

    $loader.show();

    if (startDateParam && endDateParam) {
        let storedRows = localStorage.getItem('orderTableRows');
        let tableRowHtml = '';
        if (storedRows) {
            const orderTableRows = JSON.parse(storedRows);
            const startDate = formatDate(new Date(startDateParam));
            const endDate = formatDate(new Date(endDateParam));

            orderTableRows.forEach((row) => {
                const createdAtText = $(row).find('.account-order-created-at').text();
                const createdAt = formatDate(new Date(createdAtText));
                if (createdAt >= startDate && createdAt <= endDate) {
                    tableRowHtml += $(row).prop('outerHTML');
                }
            });

            if (filteredOrderTable) {
                filteredOrderTable.destroy();
            }
            console.log(tableRowHtml);
            $('.theadfilter').removeClass('emptyhead');
            $('#filtered-order-table .tbodyfilter').empty().append(tableRowHtml);
            $('.filterpagination').remove();
            customTablePagination('filtered-order-table');

            if (!tableRowHtml) {
                $('#filtered-order-table .tbodyfilter').append('<div class="row tbody emptytable"><span>No orders placed during this period.</span></div>');
                $('.theadfilter').addClass('emptyhead');
            }

            $('#filtered-order-table').css('display', 'block');
            $('#table-account').css('display', 'none');
            $('.unfilterpagination').css('display', 'none');
            $('#calendar-container').find('.date-range-clear-button').removeClass('d-none-important');
            $('#calendar-container').siblings('#toggle-calendar').find('.toggle-calendar-label').text(`${startDateParam} - ${endDateParam}`);
            $('#calendar-container').siblings('#toggle-calendar').find('.toggle-calendar-label-img').addClass('d-none-important');
            $('#calendar-container').siblings('#toggle-calendar').attr('data-open', false);
        }
    } else {
        localStorage.removeItem('orderStartDate');
        localStorage.removeItem('orderEndDate');
    }
    $loader.hide();
}

formatDate = (date) => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
}
$('.date-range-apply-button').on('click', (e) => {
    var _this = $(e.currentTarget);
    var startDateText = _this.parent().siblings().find('#acc-order-start-date-text').text();
    var endDateText = _this.parent().siblings().find('#acc-order-end-date-text').text();
    var $loader = $('.jsc-loader-overlay');
    var tableRowHtml = ''

    $loader.show();
    if (startDateText != 'yyyy-mm-dd' && endDateText != 'yyyy-mm-dd') {
        const startDate = new Date(startDateText);
        const endDate = new Date(endDateText);
        if (startDate <= endDate) {
            let currentUrl = new URL(window.location.href);
            let params = currentUrl.searchParams;
            let pageNumber = params.get('page');

            if (pageNumber) {
                params.delete('page');
            }

            params.set('startDate', startDateText);
            params.set('endDate', endDateText);

            window.history.replaceState({}, '', `${currentUrl.pathname}?${params.toString()}`);
            getFilteredOrder();
        } else {
            alert('Please ensure that the start date of the filter is earlier than the end date.')
        }
    }
    $loader.hide();
});
$('#toggle-calendar').on('click', (e) => {
    var _this = $(e.currentTarget);
    let params = new URLSearchParams(window.location.search);
    let startDateParam = params.get('startDate');
    let endDateParam = params.get('endDate');

    if(startDateParam) {
        $('#acc-order-start-date-text').text(startDateParam);
    } else {
        $('#acc-order-start-date-text').text('yyyy-mm-dd');
    }
    if(endDateParam) {
        $('#acc-order-end-date-text').text(endDateParam);
    } else {
        $('#acc-order-end-date-text').text('yyyy-mm-dd');
    }

    var open = _this.attr('data-open') === 'true';
    _this.attr('data-open', !open);
});
initInlineDatePicker = () => {
    console.log('initInlineDatePicker');
    const today = new Date();
    const maxDate = $.datepicker.formatDate('mm/dd/yy', today);

    $("#acc-order-start-date").datepicker({
        inline: true,
        maxDate: maxDate,
        onSelect: function(dateText) {
            const selectedDate = $(this).datepicker("getDate");
            const formattedSelectedDate = formatDate(selectedDate);

            $('#acc-order-start-date-text').text(formattedSelectedDate);
            localStorage.setItem('orderStartDate', $.datepicker.formatDate('mm/dd/yy', selectedDate));
        }
    });
    $("#acc-order-end-date").datepicker({
        inline: true,
        maxDate: maxDate,
        onSelect: function(dateText) {
            const selectedDate = $(this).datepicker("getDate");
            const formattedSelectedDate = formatDate(selectedDate);

            $('#acc-order-end-date-text').text(formattedSelectedDate);
            localStorage.setItem('orderEndDate', $.datepicker.formatDate('mm/dd/yy', selectedDate));
        }
    });

    const startDate = localStorage.getItem('orderStartDate');
    const endDate = localStorage.getItem('orderEndDate');
    if (startDate) {
        $("#acc-order-start-date").datepicker("setDate", startDate);
        var [month, day, year] = startDate.split('/')
        $('#acc-order-start-date-text').text(`${year}-${month}-${day}`);
    }
    if (endDate) {
        $("#acc-order-end-date").datepicker("setDate", endDate);
        var [month, day, year] = endDate.split('/')
        $('#acc-order-end-date-text').text(`${year}-${month}-${day}`);
    }
}
customTablePagination = (id) => {
    console.log('called customTablePagination')
    var rowsPerPage = 20; // Adjust as needed
    var $rows = $(".tbodyfilter .tbody");
    var totalPages = Math.ceil($rows.length / rowsPerPage);
    var currentPage = 1;

    function showPage(page) {
        var start = (page - 1) * rowsPerPage;
        var end = start + rowsPerPage;

        $rows.hide().slice(start, end).show();
        updatePagination(page);
    }

    function updatePagination(currentPage) {
        var paginationHtml = `<nav class="pagination customer__pagination" role="navigation" aria-label="Pagination">
                <ul class="pagination__list list-unstyled" role="list">`;

        // Previous button
        if (currentPage > 1) {
            paginationHtml += `<li>
                <a href="#" class="pagination__item--prev pagination__item-arrow link motion-reduce prev-page" data-page="${currentPage - 1}" aria-label="Previous page">
                    <svg width="4" height="9" viewBox="0 0 4 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.8564 4.57146L0.046875 8.38098L0.0468753 0.761934L3.8564 4.57146Z" fill="currentColor"></path>
                    </svg>
                </a>
            </li>`;
        }

        // Page numbers
        for (var i = 1; i <= totalPages; i++) {
            if (i === currentPage) {
                paginationHtml += `<li><span aria-current="page" class="pagination__item pagination__item--current" aria-label="Page ${i}">${i}</span></li>`;
            } else {
                paginationHtml += `<li><a href="#" class="pagination__item link page-link" data-page="${i}" aria-label="Page ${i}">${i}</a></li>`;
            }
        }

        // Next button
        if (currentPage < totalPages) {
            paginationHtml += `<li>
                <a href="#" class="pagination__item--next pagination__item-arrow link motion-reduce next-page" data-page="${currentPage + 1}" aria-label="Next page">
                    <svg width="4" height="9" viewBox="0 0 4 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.8564 4.57146L0.046875 8.38098L0.0468753 0.761934L3.8564 4.57146Z" fill="currentColor"></path>
                    </svg>
                </a>
            </li>`;
        }

        paginationHtml += `</ul></nav>`;

        $(".pagination-container").html(paginationHtml);
    }

    // Initial Pagination Container
    $(".tbodyfilter").after('<div class="pagination-container filterpagination"></div>');

    // Click Event for Pagination
    $(document).on("click", ".page-link", function (e) {
        e.preventDefault();
        currentPage = parseInt($(this).data("page"));
        showPage(currentPage);
    });

    $(document).on("click", ".prev-page", function (e) {
        e.preventDefault();
        if (currentPage > 1) {
            currentPage--;
            showPage(currentPage);
        }
    });

    $(document).on("click", ".next-page", function (e) {
        e.preventDefault();
        if (currentPage < totalPages) {
            currentPage++;
            showPage(currentPage);
        }
    });

    // Initialize
    showPage(currentPage);
}
$('.date-range-clear-button').on('click', (e) => {
    localStorage.removeItem('orderStartDate');
    localStorage.removeItem('orderEndDate');
    location.href = "/account";
});
//End: Account page orders date filter
onloadOrderGallery = () => {
    if (window.location.search.includes("order-gallery")) {
        console.log("Order gallery detected!");
        $('.jsc-custom-twt #order-gallery-btn').attr('data-active', 'true');
        $('.jsc-account-order-gallery').show();
        $('.jsc-account-order-list').hide();
    }else{
        $('.jsc-custom-twt #account-btn').attr('data-active', 'true');
        $('.jsc-account-order-gallery').hide();
        $('.jsc-account-order-list').show();
    }
}
onloadOrderReorderBtn = () => {
    $('.jsc-reorder-btn').on('click', function () {
        let availableProducts = $(this).attr('data-available-products');

        if (!availableProducts) return; // Exit if no data is available

        let productArray = availableProducts.split(',').filter(Boolean);
        let $lineItemArray = [];

        productArray.forEach(item => {
            let [productId, quantity] = item.split('-');
            productId = parseInt(productId);
            quantity = parseInt(quantity);

            if (quantity > 0) {
                let $lineItemObj = {
                    id: productId,
                    quantity: quantity,
                };
                $lineItemArray.push($lineItemObj);
            }
        });

        console.log("Line Items Array:", $lineItemArray);
        CartJS.addItems($lineItemArray,
            {
                "success": function(data, textStatus, jqXHR) {
                     fetch(`${window.Shopify.routes.root}?sections=cart-drawer`)
                     .then(response => response.json())
                     .then(data => {
                       let tempDiv = document.createElement("div");
                       tempDiv.innerHTML = data['cart-drawer'];
                        // console.log("tempDiv", tempDiv);
                       let newCartDrawerContent = tempDiv.querySelector("#CartDrawer")?.innerHTML;
                       if (newCartDrawerContent) {
                         if (window.location.pathname.includes('/cart')) {
                         }else{
                            document.getElementById("CartDrawer").innerHTML = newCartDrawerContent;
                            document.querySelector("cart-drawer").classList.add("active");
                            var cartItemCountElement = document.querySelector(".jsc-cart-drawer-item-count");

                            if (cartItemCountElement) {
                                let itemCount = cartItemCountElement.getAttribute("data-cart-item-count");
                                let cartIcon = document.querySelector(".header__cart .header__icon.header__icon--cart");
    
                                if (cartIcon) {
                                    let cartBubble = cartIcon.querySelector(".cart-count-bubble");
                            
                                    if (cartBubble) {
                                        cartBubble.innerHTML = itemCount;
                                    } else {
                                        cartBubble = document.createElement("div");
                                        cartBubble.className = "cart-count-bubble";
                                        cartBubble.innerHTML = `<span aria-hidden="true">${itemCount}</span><span class="visually-hidden">${itemCount} item(s)</span>`;
                                        cartIcon.appendChild(cartBubble);
                                    }
                                }
                            }
                            setGiftPopupHeight();
                         }
                       }
                     })
                     .catch(error => console.error("Error updating cart drawer:", error));     
                 },
                 "error": function(jqXHR, textStatus, errorThrown) {
                     console.log("Error occur !", errorThrown, jqXHR);
                 }
            });
    });
}

let typingTimer;
const delay = 1950;
setCartAttr = (e, attr) =>{
    clearTimeout(typingTimer); // Clear the previous timer

    typingTimer = setTimeout(function () {
        console.log('setCartAttr', `${attr}`, $(e).val());
        CartJS.setAttribute(`${attr}`, $(e).val());
    }, delay);
}

handleMobileMultiColumns = () => {
    $('.multicolumn').each(function() {
        var $section = $(this);
        var $wrapper = $section.find('.multicolumn-list__wrapper.mobile-multicolumn-list__wrapper--2');
        
        if (!$wrapper.length) return;

        var $cards = $wrapper.find('.multicolumn-card');
        var totalCards = $cards.length;
        console.log('Section ID:', 'Total Cards:', totalCards);

        $cards.removeClass('full-width-card');

        if (totalCards % 2 !== 0) {
            $cards.last().addClass('full-width-card');
        }
    });
}

handleMobileCategoriesList = () => {
        $('.categories-list').each(function() {
        var $section = $(this);
        var $wrapper = $section.find('.categories-list__wrapper.mobile-categories-list__wrapper--columns-2');
        
        if (!$wrapper.length) return;

        var $cards = $wrapper.find('.categories-list__item');
        var totalCards = $cards.length;
        console.log('Section ID:', 'Total Cards:', totalCards);

        $cards.removeClass('full-width-card');

        if (totalCards % 2 !== 0) {
            $cards.last().addClass('full-width-card');
        }
    });
}